import React from "react";

import Layout from "../components/layout";

import SEO from "../components/seo";

const About = () => (
  <Layout>
    <SEO title="About ReadAlong" />
    <h1 className="mt-10 text-block font-bold text-5xl text-center">
      About ReadAlong
    </h1>
    <article class="prose mt-6 max-w-3xl mx-auto">
      <p>Hi, my name is Daniel. I studied Russian and Neuroscience at Duke.</p>
      <p>
        In my Russian classes, we read a lot of great short stories from some of
        the best writers in history - Tolstoy, Gogol, Dostoevsky, and more. I
        came to love and appreciate Russian literature through my classes,
        especially since I could read the text as the author originally
        intended.
      </p>
      <p>
        The problem was, sometimes those texts were <i>really</i> difficult to
        read. Take, for example,{" "}
        <a href="https://www.newyorker.com/magazine/2005/12/26/the-word-3">
          <i>The Word</i> by Vladimir Nabokov
        </a>
        . An incredibly beautiful story full of glittering words and dazzling
        descriptions, yes, but one that's difficult to read in a foreign
        language.
      </p>
      <p>
        When I did my assigned readings, I almost always tried to find an
        English version to read alongside my Russian stories. Google Translate
        didn't cut it, either. I wanted to see how a professional would
        translate the sentence so that I could pick up on idioms and other
        quirks of the language.
      </p>
      <p>
        As I started reading texts side by side, I realized that no translator
        could capture the nuances and full beauty of the Russian text I was
        reading - that's the nature of language! Still, it helped me to not get
        too lost when things got difficult.
      </p>
      <p>
        It was tedious to match up each line of text, but it was still well
        worth the effort. I felt like there should be a better way to enjoy the
        literature I was reading.
      </p>
      <p>So I built the tool I wish I'd had: ReadAlong.</p>
      <h2>Future Plans for ReadAlong</h2>
      <p>
        My goal is to add stories in more languages to the site over time. Part
        of the challenge is simply finding high quality, copyright-free stories
        and translations that I can use as material!
      </p>
      <p>If you know of any stories you'd like to see, please contact me!</p>
      <h2>About Me</h2>
      <p>
        I've always loved to learn languages. I grew up in a bilingual
        household, speaking English and a dialect of German. In high school, I
        studied <b>Spanish</b>, <b>German</b>, and <b>French</b>, dabbling in
        Italian and other various languages. When I got to college, I fell in
        love with <b>Russian</b> and was lucky enough to spend 6 weeks in Saint
        Petersburg one summer. I've dabbled with Persian, Polish, and Chinese as
        well.
      </p>
      <p>
        You can follow me on{" "}
        <a href="https://twitter.com/dmschlabach">Twitter</a>.
      </p>
    </article>
  </Layout>
);

export default About;
